//All URL's must be HTTPS. No Exceptions!
export const environment = {
  production: false,
  loginUrl: 'https://cls-uat-frontend.azurewebsites.net/ordering/login',
  resetUrl: 'https://cls-uat-frontend.azurewebsites.net/ordering/login/resetpassword',
  orderingUrl: 'https://cls-uat-frontend.azurewebsites.net/ordering/newcase',
  registerUrl: 'https://fci-dev-frontend-uat.azurewebsites.net/ordering/register',
  analytics: '2e1910a1-ace9-42e3-99ef-93a76c486a78',
  thirdPartyTermsUrl: 'https://cls-uat-frontend.azurewebsites.net/ordering/thirdpartyterms',
  frontend: 'https://cls-uat-frontend.azurewebsites.net/',
  ordering: 'https://cls-uat-frontend.azurewebsites.net/',
  providerInheritanceData: 'https://secureuat2.clsl.co.uk:5151/Provider/Edit/6011',
  insightsKey: '9931b250-968e-4a75-8c5a-07abaf646046',
  layername: 'orderinguat',
  googleAnlaytics: 'UA-20220060-2',
  userbackAccessToken: '10424|20982|1aSDyzjM8EA5P6bW8TIKPjOcl',
  productsToBypassFcaCheck: [250, 501, 509],
  FCIRegisterURL: 'https://fci-dev-frontend-uat.azurewebsites.net/ordering/register',
  hideGuardianshipBondDate: '2023-12-07 00:00:01',
  jkwDefaultLoi: 20000,
  restApiUrl: 'https://cls-restapi-uat.azurewebsites.net',
  notificationApiUrl: 'https://cls-motd-uat.azurewebsites.net/Message/pipa'
};
